import React, { useEffect, useRef } from 'react';
import Image from 'next/image';
import useObjectVisibility from '@hooks/useObjectVisibility';

import styles from './ProductCardAlt.module.scss';

export interface ProductCardProps {
  productImage: string;
  displayName: string;
  productUrl: string;
  displayPrice: string;
  salePrice: string;
  trackClick?: () => void;
  trackView?: () => void;
}

const ProductCardAlt = ({
  productImage,
  displayName,
  productUrl,
  displayPrice,
  salePrice,
  trackClick,
  trackView,
}: ProductCardProps) => {
  const productRef = useRef<HTMLElement | null>(null);
  const strippedPrice = parseInt(displayPrice?.replace?.(/\D/g, '') || '0');

  const displaySale = !!salePrice;

  const isVisible = useObjectVisibility(productRef);

  useEffect(() => {
    if (isVisible) {
      trackView?.();
    }
  }, [isVisible, trackView]);

  const Price = () => {
    if (strippedPrice === 0) return null;

    if (displaySale) {
      return (
        <p className={styles.price}>
          <span className={styles.salePrice}>{salePrice}</span>{' '}
          <span className={styles.originalPrice}>{displayPrice}</span>
        </p>
      );
    }

    return <p className={styles.price}>{displayPrice}</p>;
  };
  return (
    <article className={styles.productCard} ref={productRef}>
      <a
        className={styles.productLink}
        href={productUrl}
        onClick={() => trackClick?.()}
      >
        <div className={styles.image}>
          <Image
            src={productImage}
            alt=""
            fill
            sizes="(min-width: 895px) 200px, 220px"
            style={{
              objectFit: 'contain',
            }}
          />
        </div>
        <div className={styles.productInfo}>
          <p className={styles.name}>{displayName}</p>
          <Price />
        </div>
      </a>
    </article>
  );
};

export default ProductCardAlt;
